const FireWorks = () => {
  return (
    <div className="firework-container">
      <div className="firework"></div>
      <div className="checkmark">✔</div>
    </div>
  );
};

export default FireWorks;
